// @flow
import reducer from './reducer';
import * as selectors from './selectors';

export { reducer, selectors };



// WEBPACK FOOTER //
// ./src/store/reducers/user/index.js